<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedit"><em class="italic">This novel is based on</em></p>
<p class="dedi"><em class="italic">a version by</em></p>
<p class="dedi"><em class="italic">Sir Owain Jenkins</em></p>
<p class="dedi"><em class="italic">and aided and abetted by him</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedi.vue?63b659f4